export { Sections }

class Sections {
    #sections = []

    constructor() {
        document.querySelectorAll("section")
            .forEach(section => {
                this.#sections.push(new Section(section))
            })
    }

    get currentSection() {
        return this.#sections.findIndex(section => section.isCurrent)
    }
}

class Section {
    #running = false
    #section

    #animate() {
        const offset = window.matchMedia('(prefers-reduced-motion: reduce)')
            .matches ? 0 : 350 //ms

        this.#section.querySelectorAll("section div>*:not(.static)")
            .forEach((child, index) => {
                window.setTimeout(() =>
                    child.classList.add("show"), offset * index
                )
            })
    }

    #initIntersectionObserver(parent) {
        const observer = new IntersectionObserver(entries =>
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    observer.unobserve(entry.target)
                    this.#animate()
                }
            })
        )

        observer.observe(parent)
    }

    #initScrollListener() {
        window.addEventListener(
            "scroll",
            () => {
                if (this.#running) return
                else this.#running = true

                this.#handleScroll()

                this.#running = false
            },
            { passive: true }
        )
    }

    #handleScroll() {
        const viewport = window.innerHeight
        const { top, bottom } = this.#section.getBoundingClientRect()

        if (top < viewport && bottom > 0)
            this.#section.style.setProperty("--offset", (top / viewport).toString())
    }

    /** 
     * @param {HTMLDivElement} parent 
     */
    constructor(parent) {
        this.#section = parent
        this.#initScrollListener()
        this.#initIntersectionObserver(parent)
    }

    get isCurrent() {
        const indication = document.documentElement.clientHeight * 2 / 3
        const { top, bottom } = this.#section.getBoundingClientRect()

        return top < indication && bottom > indication
    }
}
